import Vue from 'vue';
import user from './user';

const app = {
    state: {//属性
        isRefresh:true,//是否刷新
        menuList:[],//菜单列表
        menuPathList:"",//菜单路由列表
        infoDetails_:{},
    },
    mutations: {//set方法
        
    },
    actions: {//其他方法
        // user_fillLoginInfo({ commit, state }, info) {//填充登录信息
        //     return new Promise((resolve, reject) => {
        //         resolve()
        //     })
        // }
    }
}

export default app;
